import { experimentType } from '@doordash/lib-feature-flags'
import * as Exp from './experimentConstants'

const { createExperimentToFeatureFlagMap } = experimentType

const experimentToFeatureFlagMap = createExperimentToFeatureFlagMap([
  experimentType.create('test_exp', {
    treatment: { test: true },
    control: { test: false },
  }),
  experimentType.create('dropshipping_skip_selection', {
    treatment: { dropshipping_skip_selection: true },
    control: { dropshipping_skip_selection: false },
  }),
  experimentType.create('ca_bgc_checkr_redirect', {
    treatment: { ca_bgc_checkr_redirect: true },
    control: { ca_bgc_checkr_redirect: false },
  }),
  experimentType.create('dropshipping_ab', {
    treatment: { dropshipping_ab: true },
    control: { dropshipping_ab: false },
  }),
  experimentType.create('dropshipping', {
    treatment: { dropshipping: true },
    control: { dropshipping: false },
  }),
  experimentType.create('instant_dashing', {
    treatment: { instant_dashing: true },
    control: { instant_dashing: false },
  }),
  experimentType.create('migration_dropshipping', {
    treatment: { migration_dropshipping: true },
    control: { migration_dropshipping: false },
  }),
  experimentType.create('canada_dropshipping_embed_checkr_flow', {
    treatment: { canada_dropshipping_embed_checkr_flow: true },
    control: { canada_dropshipping_embed_checkr_flow: false },
  }),
  experimentType.create('dropshipping_status', {
    treatment: { dropshipping_status: true },
    control: { dropshipping_status: false },
  }),
  experimentType.create('enable_i18n_language_selection', {
    treatment: { enable_i18n_language_selection: true },
    control: { enable_i18n_language_selection: false },
  }),
  experimentType.create('bank_onboarding', {
    treatment: { bank_onboarding: true },
    control: { bank_onboarding: false },
  }),
  experimentType.create('dx_enable_i18n_spanish', {
    treatment: { dx_enable_i18n_spanish: true },
    control: { dx_enable_i18n_spanish: false },
  }),
  experimentType.create('dx_puerto_rico_flow', {
    treatment: { dx_puerto_rico_flow: true },
    control: { dx_puerto_rico_flow: false },
  }),
  experimentType.create(Exp.RETURN_TO_APPLICATION_AUTO, {
    treatment: { return_to_application_auto: true },
    control: { return_to_application_auto: false },
  }),
  experimentType.create('dx_sign_up_international_phone_field', {
    treatment: { dx_sign_up_international_phone_field: true },
    control: { dx_sign_up_international_phone_field: false },
  }),
  experimentType.create('w9_experiment', {
    treatment: { w9_experiment: true },
    control: { w9_experiment: false },
  }),
  experimentType.create('orientation_experiment', {
    treatment: { orientation_experiment: true },
    control: { orientation_experiment: false },
  }),
  experimentType.create('instant_dashing_v2', {
    treatment: { instant_dashing_v2: true },
    control: { instant_dashing_v2: false },
  }),
  experimentType.create('in_app_education_v3', {
    treatment: { in_app_education_v3: true },
    control: { in_app_education_v3: false },
  }),
  experimentType.create('dasher_signup_ui_refresh', {
    treatment: { dasher_signup_ui_refresh: true },
    control: { dasher_signup_ui_refresh: false },
  }),
  experimentType.create('background_check_experiment', {
    treatment: { background_check_experiment: true },
    control: { background_check_experiment: false },
  }),
  experimentType.create('application_status_experiment', {
    treatment: { application_status_experiment: true },
    control: { application_status_experiment: false },
  }),
  experimentType.create(Exp.DX_CRO_LP_GRADUATION_Q1_2020, {
    treatment: { [Exp.DX_CRO_LP_GRADUATION_Q1_2020]: true },
    control: { [Exp.DX_CRO_LP_GRADUATION_Q1_2020]: false },
  }),
  experimentType.create(Exp.BACKGROUND_CHECK_SPLIT_3PG, {
    treatment: { [Exp.BACKGROUND_CHECK_SPLIT_3PG]: true },
    control: { [Exp.BACKGROUND_CHECK_SPLIT_3PG]: false },
  }),
  experimentType.create(Exp.DX_ID_FAST_PAY_Q1_2020, {
    treatment: { [Exp.DX_ID_FAST_PAY_Q1_2020]: true },
    control: { [Exp.DX_ID_FAST_PAY_Q1_2020]: false },
  }),
  experimentType.create(Exp.COVID_RUNNERS_Q1_2020, {
    treatment: { [Exp.COVID_RUNNERS_Q1_2020]: true },
    control: { [Exp.COVID_RUNNERS_Q1_2020]: false },
  }),
  experimentType.create(Exp.NEEDS_VEHICLE_INFO, {
    treatment: { [Exp.NEEDS_VEHICLE_INFO]: true },
    control: { [Exp.NEEDS_VEHICLE_INFO]: false },
  }),
])

export default experimentToFeatureFlagMap
